<template>
    <el-dialog title="接口明细" :visible.sync="dialogApiVisible" @open="open" :close-on-click-modal="false">
         <el-form :model="apiDetail" label-position="left" :disabled="true">
            <el-row :gutter="5">
               <el-col :span="12">
                  <el-form-item label="接口类型" label-width="100px">
                      <el-input v-model="apiDetail.portname" autocomplete="off"></el-input>
                   </el-form-item>
               </el-col>
               <el-col :span="12">
                  <el-form-item label="请求号" label-width="100px">
                     <el-input v-model="apiDetail.reqid" autocomplete="off"></el-input>
                  </el-form-item>
               </el-col>
            </el-row>
            <el-row :gutter="5">
               <el-col :span="12">
                  <el-form-item label="请求时间" label-width="100px">
                      <el-input v-model="apiDetail.reqtime" autocomplete="off"></el-input>
                  </el-form-item>
               </el-col>
               <el-col :span="12">
                  <el-form-item label="状态码" label-width="100px">
                     <el-input v-model="apiDetail.code" autocomplete="off"></el-input>
                  </el-form-item>
               </el-col>
            </el-row>
            <el-form-item label="请求报文" label-width="100px">
               <json-viewer :value="apiDetail.request" boxed :copyable="{copyText: '复制', copiedText: '复制中', timeout: 2000}" :expand-depth="7"  style="border-color:#E4E7ED;border:1px solid #DCDFE6;border-radius:4px;background-color:#F5F7FA"></json-viewer>
            </el-form-item>
             <el-form-item label="回复报文" label-width="100px">
                  <json-viewer :value="apiDetail.response" boxed :copyable="{copyText: '复制', copiedText: '复制中', timeout: 2000}" :expand-depth="7" style="border-color:#E4E7ED;border:1px solid #DCDFE6;border-radius:4px;background-color:#F5F7FA"></json-viewer>
            </el-form-item>
         </el-form>
    </el-dialog>
</template>
<script>
export default {
    props:{
        apiDetail:Object
    },
    data () {
        return {
            dialogApiVisible:false,
            request:{},
            response:{}
        }
    },
    methods: {
       open(){
          console.log(typeof this.apiDetail.request);
          if(this.apiDetail.request!=''&&typeof this.apiDetail.request == "string"){
            this.apiDetail.request = JSON.parse(this.apiDetail.request)
          }
          if(this.apiDetail.response!=''&&typeof this.apiDetail.response == "string"){
            this.apiDetail.response=JSON.parse(this.apiDetail.response)
          }
       },
    }
}
</script>